import { useStore } from '@tanstack/react-store'
import { useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'

import { resetUserList, userListStore } from 'shared/store/userList'
import { getAllFilterParams } from 'shared/utils/getFilterParams'
import { getURLFromFilterParams, isSameParams } from 'shared/utils/getURLFromFilterParams'
import { paramsToTableStateAdapter, tableStateToParamsAdapter } from 'shared/utils/sortAdapter'
import { ReactTablePaged } from 'uikit/ReactTable'
import {
  Container,
  SnippetsContainer,
  SnippetsContainerMain,
  SnippetsContainerRightAside,
} from 'uikit/layout'
import { UserFilter } from './UserFilter'
import { columns } from './UserList.config'
import { useFetchUserList } from './hooks/useFetchUserList'

export const UserList = () => {
  const { params } = useParams()
  const history = useHistory()
  const urlParams = getAllFilterParams(params)

  useEffect(() => {
    userListStore.setState((state) => {
      if (isSameParams(params, state.filter)) {
        return state
      }
      return {
        ...state,
        filter: getAllFilterParams(params),
        page: 0,
      }
    })
  }, [params])

  const { page, totalPages, sort, totalElements, filter } = useStore(userListStore)
  const { data, isFetching: isLoading } = useFetchUserList({ urlParams })

  useEffect(() => {
    return () => resetUserList()
  }, [])

  const onPageChange = (page) => {
    userListStore.setState((state) => ({
      ...state,
      page: page - 1,
    }))
  }

  const onSortChange = (state) => {
    const newSort = tableStateToParamsAdapter(state)

    userListStore.setState((state) => ({
      ...state,
      sort: newSort,
    }))
  }

  const onFilterChange = (nextFilter) => {
    userListStore.setState((state) => ({
      ...state,
      filter: nextFilter,
    }))

    const urlFilterParams = getURLFromFilterParams(nextFilter)
    const newPath = `/user${urlFilterParams}`

    if (history.location.pathname !== newPath) {
      history.push(newPath)
    }
  }

  return (
    <Container>
      <SnippetsContainer indentTop={70}>
        <SnippetsContainerMain>
          <ReactTablePaged
            storageId="user-list"
            onRowClick={(row) => history.push(`/user/card/0/${row.id}`)}
            currentPage={page + 1}
            totalPages={totalPages}
            isLoading={isLoading}
            columns={columns}
            data={data?.users || []}
            initialState={{
              sorting: paramsToTableStateAdapter(sort),
            }}
            onPageChange={onPageChange}
            onSortingChange={onSortChange}
          />
        </SnippetsContainerMain>

        <SnippetsContainerRightAside>
          <UserFilter totalItems={totalElements} value={filter} onChange={onFilterChange} />
        </SnippetsContainerRightAside>
      </SnippetsContainer>
    </Container>
  )
}
